/* eslint-disable global-require */
const configureStore = __DEV__ ? require('./configureStore.dev').default : require('./configureStore.prod').default;

export default configureStore;



// WEBPACK FOOTER //
// ./store/configureStore.js